import request from '@/utils/request'

export const getMerchantFeatures = () => request.get('/admin/merchant-features')
export const getMerchantFeature = (feature) => request.get(feature === 'vip' ? '/admin/vip-feature' : '/admin/lottery/activity')
export const putMerchantFeature = (feature, intent) => request.put(feature === 'vip' ? '/admin/vip-feature' : '/admin/lottery/activity', intent)
